import { Component, OnInit, Input } from "@angular/core";

@Component({
	selector: "app-toolbar",
	templateUrl: "./toolbar.component.html",
	styleUrls: ["./toolbar.component.scss"],
})
export class ToolbarComponent implements OnInit {
	@Input() borderClass: string | { [className: string]: boolean };
	@Input() containerClass: string | { [className: string]: boolean };

	constructor() {}

	ngOnInit(): void {
		this.borderClass = this.borderClass || "border-bottom py-1 py-md-3 mb-md-3 bg-white";
		this.containerClass = this.containerClass || "container-md d-flex justify-content-between";
	}
}
